import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { ModalModel, ModalContext, Text } from '@notino/react-styleguide';

import ErrorBoundary from '@components/ErrorBoundary';
import { WatchdogModal } from '@sharedComponents/Watchdog/WatchdogModal';

import { IWatchdogProps } from './model';
import { ButtonWrapper } from './styled';
import { useWatchdogActive } from './useWatchdogActive';
import { watchdogMessages } from './watchdogMessages';

export const Watchdog = ({ variant, id, children }: IWatchdogProps) => {
  const { toggleModal } = ModalContext.useModalContext();
  const { watchdogActive, setWatchdogActiveCache } = useWatchdogActive({
    variant,
  });

  if (!variant.showWatchdog) {
    return null;
  }

  const handleShowModal: React.MouseEventHandler = (e) => {
    e.stopPropagation();
    toggleModal(
      <WatchdogModal variant={variant} onSuccess={setWatchdogActiveCache} />,
      {
        header: (
          <Text typography="titleLarge">
            <FormattedMessage {...watchdogMessages.watchdogHeader} />
          </Text>
        ),
        type: ModalModel.Types.default,
        withFocusTrap: true,
        positionBottomOnMobile: true,
      }
    );
  };

  const childrenContent =
    typeof children === 'function' ? children({ watchdogActive }) : children;

  return (
    <ErrorBoundary>
      <div id={id}>
        <ButtonWrapper onClick={handleShowModal}>
          {childrenContent}
        </ButtonWrapper>
      </div>
    </ErrorBoundary>
  );
};
